import type { paths } from './auto-gen-types'
import { generateUserIconUrl } from './converters'

type APINotifications = paths['/notifications']['get']['responses']['200']['content']['application/json']

export const apiNotificationsToNotifications = (notifications: APINotifications) => ({
  share_album: (notifications.share_album || []).map(notification => ({
    id: notification.date,
    is_new: !notification.read,
    date: new Date(notification.date),
    num: notification.num,
    status: notification.notification_type === 'ALBUM_OWNER_TRANSFERRED' ? 'owner_transferred' as const
      : notification.notification_type === 'ALBUM_INVITED' ? 'pending' as const
      : 'append' as const,
    thumbnail_url: notification.thumbnail_url,
    album_id: notification.album_id,
    album_title: notification.album_title,
    user_id: notification.user_id,
    user_metamory_id: notification.user_metamory_id || '',
    user_name: notification.user_name,
    user_icon: generateUserIconUrl(notification.user_id)
  })),
  dm: (notifications.dm || []).map(notification => ({
    id: notification.date,
    is_new: !notification.read,
    date: new Date(notification.date),
    thumbnail_url: notification.thumbnail_url,
    num: notification.num,
    user_id: notification.user_id,
    user_metamory_id: notification.user_metamory_id || '',
    user_name: notification.user_name,
    user_icon: generateUserIconUrl(notification.user_id)
  })),
  reaction: (notifications.reaction || []).map(notification => ({
    id: notification.date,
    is_new: notification.is_new,
    date: new Date(notification.date),
    thumbnail_url: notification.thumbnail_url,
    photo_id: notification.photo_id,
    reactions: notification.reactions.map(reaction => ({
      reaction: reaction.reaction,
      user_id: reaction.users[0]?.user_id || '',
      user_icon: reaction.users[0]?.user_id ? generateUserIconUrl(reaction.users[0].user_id) : ''
    }))
  }))
})

export const countNewNotifications = (notifications: APINotifications) => ({
  share_album: (notifications.share_album || []).filter(notification => !notification.read).length,
  dm: (notifications.dm || []).filter(notification => !notification.read).length,
  reaction: (notifications.reaction || []).filter(notification => notification.is_new).length
})
